/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Faq_Q1Inputs */

const en_pc_alt_faq_q1 = /** @type {(inputs: Pc_Alt_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is PdfCraft a good free alternative to Adobe Acrobat?`)
};

const zh_pc_alt_faq_q1 = /** @type {(inputs: Pc_Alt_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 是好用的免费 Adobe Acrobat 替代品吗？`)
};

/**
* | output |
* | --- |
* | "Is PdfCraft a good free alternative to Adobe Acrobat?" |
*
* @param {Pc_Alt_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_faq_q1 = /** @type {((inputs?: Pc_Alt_Faq_Q1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Faq_Q1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_faq_q1(inputs)
	return zh_pc_alt_faq_q1(inputs)
});
export { pc_alt_faq_q1 as "pc.alt.faq.q1" }